import React, { SVGProps } from 'react'

/** Feature-local horizontal kebab (•••) glyph for the actions-menu trigger. */
const SvgDots = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill={props.fill || 'currentColor'}
    aria-hidden="true"
    {...props}
  >
    <circle cx={3.5} cy={9} r={1.5} />
    <circle cx={9} cy={9} r={1.5} />
    <circle cx={14.5} cy={9} r={1.5} />
  </svg>
)
export default SvgDots
